<div class="flex flex-col h-full min-h-0 overflow-hidden p-3">
    <app-document-types-list [showAddButton]="true" [showMenu]="true" [isSelectable]="false" [showHeading]="false"
        [documentTypes]="docTypes" [docTypeLoading]="docTypeLoading"
        (documentTypeSelected)="onDocumentTypeSelected($event)" (refetchDocumentTypes)="getDocumentTypes()">
    </app-document-types-list>
</div>
